import { useState, useEffect, useRef } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta6({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const containerRef = useRef(null);

	const [connections, setConnections] = useState([
		{ from: '', to: '' },
		{ from: '', to: '' },
		{ from: '', to: '' },
	]);
	const [btn1, setBtn1] = useState('');
	const [btn2, setBtn2] = useState('');
	const [btn3, setBtn3] = useState('');
	const [btn4, setBtn4] = useState('');
	const [concept1, setConcept1] = useState('');
	const [concept2, setConcept2] = useState('');
	const [concept3, setConcept3] = useState('');
	const [concept4, setConcept4] = useState('');

	const [selectedPalabra, setSelectedPalabra] = useState(null);
	const [selectedPal, setSelectedPal] = useState(null);
	const respuestas = [
		{ from: 'Frustación', to: 'Identificar la causa y ofrecer apoyo técnico o emocional.' },
		{ from: 'Entusiasmo', to: 'Canalizar la energía hacia metas productivas.' },
		{ from: 'Ansiedad', to: 'Reconocer la emoción y ofrecer acompañamiento para manejarla.' },
	];
	const handleWordClick = (id, word) => {
		let array = connections;
		setSelectedPal(id);
		switch (id) {
			case 1:
				setBtn1('btn1');
				setSelectedPalabra('btn1');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 2:
				setBtn2('btn2');
				setSelectedPalabra('btn2');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 3:
				setBtn3('btn3');
				setSelectedPalabra('btn3');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;

			default:
				break;
		}
	};
	const handleConceptClick = (id, word) => {
		let array = connections;

		switch (id) {
			case 4:
				setConcept1(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 5:
				setConcept2(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 6:
				setConcept3(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			default:
				break;
		}

		setSelectedPalabra(null);
		setSelectedPal(null);
	};

	const arraysAreEqual = (arr1, arr2) => {
		if (arr1.length !== arr2.length) return false;
		return arr1.every((obj, index) => JSON.stringify(obj) === JSON.stringify(arr2[index]));
	};

	const siguiente = () => {
		if (arraysAreEqual(connections, respuestas)) {
			setRespuesta('pregunta6', connections, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta6', connections, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(7);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>6.</div>Relaciona cada emoción con una respuesta adecuada en el contexto laboral:
						</div>
					</Grid>
				</Grid>
			</Container>
			<div ref={containerRef} className='matching-container'>
				{/* <canvas ref={canvasRef} className='matching-canvas' /> */}
				<div className='columns'>
					<div className='column words'>
						{/* {words.map((word, index) => (
							<div key={index} id={`${word}`} className='word' onMouseDown={() => (connections.length < 3 ? handleStartConnection(`${word}`) : null)}>
								{word}
							</div>
						))} */}
						<div className={`word ${btn1}`} onClick={() => handleWordClick(1, 'Frustación')}>
							Frustación
						</div>
						<div className={`word ${btn2}`} onClick={() => handleWordClick(2, 'Entusiasmo')}>
							Entusiasmo
						</div>
						<div className={`word ${btn3}`} onClick={() => handleWordClick(3, 'Ansiedad')}>
							Ansiedad
						</div>
					</div>
					<div className='column concepts'>
						{/* {concepts.map((concept, index) => (
							<div key={index} id={`${concept}`} className='concept' onMouseUp={() => (connections.length < 3 ? handleEndConnection(`${concept}`) : null)}>
								{concept}
							</div>
						))} */}
						<div className={`concept ${concept1}`} onClick={() => handleConceptClick(4, 'Reconocer la emoción y ofrecer acompañamiento para manejarla.')}>
							Reconocer la emoción y ofrecer acompañamiento para manejarla.
						</div>
						<div className={`concept ${concept2}`} onClick={() => handleConceptClick(5, 'Canalizar la energía hacia metas productivas.')}>
							Canalizar la energía hacia metas productivas.
						</div>
						<div className={`concept ${concept3}`} onClick={() => handleConceptClick(6, 'Identificar la causa y ofrecer apoyo técnico o emocional.')}>
							Identificar la causa y ofrecer apoyo técnico o emocional.
						</div>
					</div>
				</div>
			</div>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
